import { Checkbox } from '../../../../../../widgets/checkbox';
import { FormControl } from '../../../../../../widgets/formControl';
import React from 'react';
import { ValueInput } from 'src/components/widgets/FormBuilderTool/editForm';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';
import useComposerStore from '../../../configurator-composer/composer/composerStore';
import Stack from '../../../../../../widgets/stack/stack';
import ComposerPreview from '../composerPreview';
import { ComposerEmptyState, ComposerEyebrow, ComposerPanel, ComposerPanelHeader, ComposerPanelTitle, ComposerScrollBody } from '../composerWorkspace';

const ComposerStartedContainer = styled.div`
    display: grid;
    width: 100%;
    height: 100%;
    min-width: 0;
    min-height: 0;
    grid-template-columns: minmax(220px, var(--c2, 2fr)) minmax(280px, var(--c3, 3fr)) minmax(320px, var(--c4, 3fr));
    overflow: hidden;
`;

const QuantityPanel = styled(ComposerPanel)`
    display: flex;
    flex-direction: column;
`;
const ComposerStartedInnerContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const ComposerSettings: React.FC = ({}) => {
    const [productQuantity, setProductQuantity] = useComposerStore((state) => [state.productQuantity, state.setProductQuantity]);

    const onCheck = (checked: boolean) => {
        const productQuantity = checked ? new MPlaza.QuantityRule() : null;
        setProductQuantity(productQuantity);
    };

    const onPropertyChange = (property: 'minQuantity' | 'maxQuantity' | 'step', value: number | undefined | null) => {
        if (productQuantity) {
            //check if min > max or max < min
            if (
                value &&
                property === 'minQuantity' &&
                value !== undefined &&
                productQuantity.get('maxQuantity') !== undefined &&
                value > (productQuantity.get('maxQuantity') || Number.MAX_VALUE)
            ) {
                // If min > max, set min to max
                productQuantity.set('minQuantity', productQuantity.get('maxQuantity'));
            } else if (
                value &&
                property === 'maxQuantity' &&
                value !== undefined &&
                productQuantity.get('minQuantity') !== undefined &&
                value < (productQuantity.get('minQuantity') || 0)
            ) {
                // If max < min, set max to min
                productQuantity.set('maxQuantity', productQuantity.get('minQuantity'));
            }
            productQuantity.set(property as any, value);
            setProductQuantity(productQuantity.clone());
        }
    };

    return (
        <ComposerStartedContainer>
            <QuantityPanel>
                <ComposerPanelHeader>
                    <ComposerPanelTitle>
                        <ComposerEyebrow>{T._('Quantity', 'Admin')}</ComposerEyebrow>
                    </ComposerPanelTitle>
                </ComposerPanelHeader>
                <ComposerScrollBody>
                    <ComposerStartedInnerContainer>
                        <Checkbox checked={!!productQuantity} onChange={onCheck} label={T._('Allow the user to change quantities', 'Admin')} />
                        {!!productQuantity && (
                            <Stack>
                                <FormControl
                                    label={T._('Minimum Quantity', 'Admin')}
                                    tooltipLabelHtml={T._("Leave empty if you don't want a minimum quantity. It will be 1.", 'Admin')}
                                >
                                    <ValueInput
                                        type='number'
                                        value={productQuantity.get('minQuantity') || ''}
                                        min={productQuantity.get('minQuantity') || 1}
                                        max={(productQuantity.get('maxQuantity') || Number.MAX_VALUE) - 1}
                                        onChange={(e) => onPropertyChange('minQuantity', e.target.valueAsNumber)}
                                    />
                                </FormControl>
                                <FormControl
                                    label={T._('Maximum Quantity', 'Admin')}
                                    tooltipLabelHtml={T._("Leave empty if you don't want a maximum quantity.", 'Admin')}
                                >
                                    <ValueInput
                                        type='number'
                                        value={productQuantity.get('maxQuantity') || ''}
                                        min={productQuantity.get('minQuantity') || 0}
                                        max={productQuantity.get('maxQuantity') || Number.MAX_VALUE}
                                        onChange={(e) => onPropertyChange('maxQuantity', e.target.valueAsNumber)}
                                    />
                                </FormControl>
                                <FormControl label={T._('Step', 'Admin')} tooltipLabelHtml={T._("Leave empty if you don't want a step value.", 'Admin')}>
                                    <ValueInput
                                        type='number'
                                        value={productQuantity.get('step') || ''}
                                        min={1}
                                        onChange={(e) => onPropertyChange('step', e.target.valueAsNumber)}
                                    />
                                </FormControl>
                            </Stack>
                        )}
                    </ComposerStartedInnerContainer>
                </ComposerScrollBody>
            </QuantityPanel>
            <ComposerPanel>
                <ComposerPanelHeader>
                    <ComposerPanelTitle>
                        <ComposerEyebrow>{T._('Product settings', 'Admin')}</ComposerEyebrow>
                    </ComposerPanelTitle>
                </ComposerPanelHeader>
                <ComposerEmptyState>{T._('No additional product settings are connected in this section.', 'Admin')}</ComposerEmptyState>
            </ComposerPanel>
            <ComposerPreview />
        </ComposerStartedContainer>
    );
};

export default ComposerSettings;
